import { Button, Input } from '@ds';
import { MdOutlineFolderOpen } from 'react-icons/md';
import { useContext } from 'react';
import { AuthContext } from '@lp/core/auth';
import { CaseStatus } from '@/api/apis/case';
import { SelectedStatus } from './SelectedStatus';
import { CaseBoardPermissions } from '@/permissions';

type EditGroupProps = {
  title: string;
  saveBtnText: string;
  groupName: string;
  selectedStatuses: CaseStatus[];
  onSave: () => void;
  setGroupName: (name: string) => void;
  onStatusRemove: (status: CaseStatus) => void;
};

export const EditGroup = ({
  title,
  saveBtnText,
  groupName,
  selectedStatuses,
  onSave,
  setGroupName,
  onStatusRemove,
}: EditGroupProps) => {
  const { checkPermission } = useContext(AuthContext);
  const canCreateCustomGroup = checkPermission(CaseBoardPermissions.CaseBoardUpdate);

  const saveDisabled = !groupName || !selectedStatuses.length || !canCreateCustomGroup;
  return (
    <div className="flex flex-col gap-5 bg-info-80 rounded-lg p-3">
      <div className="flex justify-between items-center">
        <div className="text-l-sb">{title}</div>
        <Button
          disabled={saveDisabled}
          startContent={<MdOutlineFolderOpen size={18} color={saveDisabled ? '#595C6E' : '#3F83F8'} />}
          variant="light"
          className="h-8 px-3 text-info-40 disabled:text-base-20"
          onClick={onSave}
        >
          {saveBtnText}
        </Button>
      </div>
      <Input
        placeholder="Group name"
        value={groupName}
        isDisabled={!canCreateCustomGroup}
        onChange={(e) => setGroupName(e.target.value)}
        classNames={{
          inputWrapper: 'bg-info-70! rounded-lg',
        }}
      />
      <div>
        <div className="text-m-m mb-2">Statuses:</div>
        {selectedStatuses.length ? (
          <div className="overflow-y-auto max-h-88">
            {selectedStatuses.map((selectedStatus: CaseStatus) => (
              <SelectedStatus
                key={selectedStatus}
                onClick={() => onStatusRemove(selectedStatus)}
                status={selectedStatus}
              />
            ))}
          </div>
        ) : (
          <div className="text-m-r text-base-35">No statuses have been added</div>
        )}
      </div>
    </div>
  );
};
